import React from 'react';
import { Typography } from '@mui/material';

export const QuotationSummaryTitle: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <Typography
            variant="h4"
            sx={{ paddingTop: '12px', marginBottom: '5px' }}
        >
            {props.children}
        </Typography>
    );
};
